import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-next-to-go-show-more',
    templateUrl: './next-to-go-show-more.component.html',
    styleUrls: ['../next-to-go.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NextToGoShowMoreComponent {
    @Input() expand = false;
    @Output() expandChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(public sitecore: Sitecore) {}

    toggled(): void {
        this.expand = !this.expand;
        this.expandChange.emit(this.expand);
    }

    get message(): string {
        return this.expand ? this.sitecore.globalMessages.ShowLess : this.sitecore.globalMessages.ShowMore;
    }
}
